import account from './account';
import activity from './activity';
import APISettings from './api-settings';
import billing from './billing';
import companies from './companies';
import configurations from './configurations';
import customerGroup from './customer-group';
import customers from './customers';
import discounts from './discounts';
import explore from './explore';
import help from './help';
import home from './home';
import onboarding from './onboarding';
import partnerPortal from './partner-portal';
import partners from './partners';
import pricing from './pricing';
import products from './products';
import sections from './sections';
import shippingMethods from './shipping-methods';
import storefrontOptions from './storefront-options';
import storefrontWidgets from './storefront-widgets';
import synclog from './synclog';
import themes from './themes';

export default {
  account,
  activity,
  billing,
  companies,
  customers,
  customer_group: customerGroup,
  discounts,
  explore,
  home,
  onboarding,
  sections,
  shipping_methods: shippingMethods,
  partner_portal: partnerPortal,
  api_settings: APISettings,
  configurations,
  storefront_options: storefrontOptions,
  storefront_widgets: storefrontWidgets,
  synclog,
  themes,
  partners,
  products,
  pricing,
  help,
};
